export default __webpack_public_path__ + "static/media/mobileWef7Full.7125ae32.png";